module.exports = __webpack_public_path__ + "img/header_blue.27e6c4b5.jpg";